/**
 * ToggleField - Reusable toggle/checkbox component
 * Uses Tailwind utilities for layout, DaisyUI for toggle styling
 */

interface ToggleFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const ToggleField = ({
  label,
  checked,
  onChange,
  disabled = false,
}: ToggleFieldProps) => {
  return (
    <div class="flex items-center gap-2">
      <input
        type="checkbox"
        class="toggle toggle-primary"
        checked={checked}
        onChange={() => onChange(!checked)}
        disabled={disabled}
      />
      <span class="text-sm font-medium">{label}</span>
    </div>
  );
};
